import { Loader2 } from 'lucide-react'

interface LoadingSectionProps {
  title?: string
  height?: string
}

export default function LoadingSection({ title, height = 'h-64' }: LoadingSectionProps) {
  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${height}`}>
      {title && (
        <div className="h-6 w-48 bg-gray-200 rounded animate-pulse mb-4" />
      )}
      <div className="flex flex-col items-center justify-center h-full">
        <Loader2 className="w-8 h-8 text-blue-500 animate-spin mb-3" />
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  )
}
